import React, { Component } from "react";

//Import CSS
import "../financeiro.css";

//Import internal components
import AppContext from "../../appContext";
import TrackingSearchButton from "../financeiro-inputs/tracking-search-button";
import TableHead from "./tabela-dropdown/table-head";
import EmptyState from "../../shared/components/generic/empty-state/empty-state";
import { Search } from "react-bootstrap-icons";
import CnpjUtils from "../../shared/utils/CnpjUtils";
import { statusParcela } from "../status-parcela";
import { proximoVencimento } from "../proximo-vencimento";

//Import external components

import { Redirect } from "react-router-dom";
import Moment from "moment";
import Swal from "sweetalert2";
import { redirectPage } from "../../components/utils/redirectpage";
import { Relacionamento } from "../../Functions/gestao-laboratorios/relacionamento";
import { TextField, Divider, Collapse } from "@material-ui/core";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//Import images

class BuscaFaturas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pedido_laboratorio: "",
      pedido_otica: "",
      table: null,
      dia_inicio: new Date().setDate(new Date().getDate() - 30),
      dia_fim: new Date(),
      data_inicio: Moment(new Date().setDate(new Date().getDate() - 30)).format("YYYY-MM-DD"),
      data_fim: Moment(new Date()).format("YYYY-MM-DD"),
      resposta_tabela: false,
      loading: false,
      redirectL: false,
      result100: false,
      result404: false,
      result504: false,
      campoCnpjLiberado: false,
      redes: [],
      open: "",
      arrow: "",
      status: "",
      statusMessage: null,
      tableExport:[],
      filtro_numero_documento: "",
      filtro_vencimento_dia_inicio: null,
      filtro_vencimento_dia_fim: null,
      filtro_vencimento_data_inicio: "",
      filtro_vencimento_data_fim: "",
      filtro_valor_minimo: "",
      filtro_valor_maximo: "",
      filtro_nota_fiscal: "",
      filtro_serie_nota_fiscal: "",
    };

    if (sessionStorage.getItem("token") !== null) {
      BuscaFaturas.contextType = AppContext;
      this.handleChange_data_inicio = this.handleChange_data_inicio.bind(this);
      this.handleChange_data_fim = this.handleChange_data_fim.bind(this);
      this.changeState = this.changeState.bind(this);
      this.integraPedido = this.integraPedido.bind(this);
      this.validarCampos = this.validarCampos.bind(this);

      let role = false;

      role = BuscaFaturas.contextType._currentValue.userSession.modulos.find(element => element === "Financeiro");
      if (!role) {
        this.state = { redirect: true };
      }
    } else {
      this.state = { redirectL: true };
    }
  }

  borderColor(idElement, color = "#f70017") {
    //#f70017  #B5B5B5
    if (typeof idElement === "object") {
      idElement.map(el => {
        if (document.getElementById(el)) {
          return (document.getElementById(el).style.boxShadow = `0 0 0 1px ${color}`);
        }
        return null;
      });
    } else {
      document.getElementById(idElement).style.boxShadow = `0 0 0 1px ${color}`;
    }
  }

  handleChange_data_inicio = date => {
    //trata o formato da data
    const diaInicio = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      //seta data para integração
      data_inicio: diaInicio,
      //seta data para exibir no input date
      dia_inicio: date,
    });
  };

  handleChange_data_fim = date => {
    //trata o formato da data
    const diaFim = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      //seta data para integração
      data_fim: diaFim,
      //seta data para exibir no input date
      dia_fim: date,
    });
  };

  handleChangeFiltroVencimentoInicio = date => {
    const dia = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      filtro_vencimento_data_inicio: dia,
      filtro_vencimento_dia_inicio: date,
    });
  };

  handleChangeFiltroVencimentoFim = date => {
    const dia = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      filtro_vencimento_data_fim: dia,
      filtro_vencimento_dia_fim: date,
    });
  };

  handleChangeFiltro = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  formatCurrencyDisplay = value => {
    if (!value) return "";
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  handleCurrencyChange = name => e => {
    let raw = e.target.value.replace(/[^0-9]/g, "");
    if (raw === "") {
      this.setState({ [name]: "" });
      return;
    }
    const decimal = (parseInt(raw, 10) / 100).toFixed(2);
    this.setState({ [name]: decimal });
  };

  getValorError = () => {
    const min = this.state.filtro_valor_minimo;
    const max = this.state.filtro_valor_maximo;
    if (min && max && parseFloat(min) > parseFloat(max)) {
      return { min: "Valor mínimo maior que o máximo", max: "Valor máximo menor que o mínimo" };
    }
    if (min && !max) return { min: "", max: "Preencha o valor máximo" };
    if (!min && max) return { min: "Preencha o valor mínimo", max: "" };
    return { min: "", max: "" };
  };

  getDataVencimentoError = () => {
    const ini = this.state.filtro_vencimento_data_inicio;
    const fim = this.state.filtro_vencimento_data_fim;
    if (ini && fim && ini > fim) {
      return { ini: "Data inicial maior que a final", fim: "Data final menor que a inicial" };
    }
    if (ini && !fim) return { ini: "", fim: "Preencha a data final" };
    if (!ini && fim) return { ini: "Preencha a data inicial", fim: "" };
    return { ini: "", fim: "" };
  };

  changeState() {
    this.setState({
      loading: true,
      data_tabela: [],
      resposta_tabela: false,
    });

    let valido = this.validarCampos();
    if (valido) {
      this.context.showLoading();
      this.integraPedido();
    }
  }

  validarCampos() {
    this.props.handleChangeProps("labError", null, "");
    if (!Boolean(this.props.laboratorio_dados?.laboratorio_nome)) {
      this.setState({ loading: false });
      this.props.handleChangeProps("labError", null, "Selecione um laboratório");
      this.context.hideLoading();
      return;
    } else if (this.context.userSession.redeOticas && this.props.redeOticaAux && !this.props.cnpj_number) {
      this.setState({
        loading: false,
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Selecione uma ótica.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor("cnpj_number");
      return;
    } else if (this.props.input_cnpj && this.props.redeOticaAux && !this.props.cnpj_number && !this.context.userSession.redeOticas) {
      this.setState({
        loading: false,
      });
      this.context.hideLoading();
      Swal.fire({
        text: "O campo CNPJ é obrigatório.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor("cnpj_number");
      return;
    }

    if (this.state.data_inicio === "" || this.state.data_fim === "") {
      this.setState({
        loading: false,
      });
      this.context.hideLoading();
      Swal.fire({
        text: " Por favor, informe um período válido para o seu pedido.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor(["data_inicio", "data_fim"]);
      return;
    } else if (this.state.data_inicio > this.state.data_fim) {
      this.setState({
        loading: false,
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Período da busca inválido: Data inicial maior que data final.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor(["data_inicio", "data_fim"]);
      return;
    } else {
      let ini = new Date(this.state.data_inicio);
      let fim = new Date(this.state.data_fim);
      let diff = (fim.getTime() - ini.getTime()) / 1000 / 3600 / 24;
      if (diff > 60) {
        this.setState({
          loading: false,
        });
        this.context.hideLoading();
        Swal.fire({
          text: "O período de busca não pode ser superior a 60 dias.",
          title: "Aviso",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        });
        this.borderColor(["data_inicio", "data_fim"]);
        return;
      }
    }

    if (this.props.novosFiltrosFinanceiros) {
      const vencIni = this.state.filtro_vencimento_data_inicio;
      const vencFim = this.state.filtro_vencimento_data_fim;
      if ((vencIni && !vencFim) || (!vencIni && vencFim)) {
        this.setState({ loading: false });
        this.context.hideLoading();
        Swal.fire({ text: "Preencha ambas as datas de vencimento.", title: "Aviso", icon: "warning", confirmButtonColor: "#3085d6", confirmButtonText: "Ok" });
        return;
      }
      if (vencIni && vencFim && vencIni > vencFim) {
        this.setState({ loading: false });
        this.context.hideLoading();
        Swal.fire({ text: "Data de vencimento inicial maior que a final.", title: "Aviso", icon: "warning", confirmButtonColor: "#3085d6", confirmButtonText: "Ok" });
        return;
      }

      const valMin = this.state.filtro_valor_minimo;
      const valMax = this.state.filtro_valor_maximo;
      if ((valMin && !valMax) || (!valMin && valMax)) {
        this.setState({ loading: false });
        this.context.hideLoading();
        Swal.fire({ text: "Preencha ambos os campos de valor (mínimo e máximo).", title: "Aviso", icon: "warning", confirmButtonColor: "#3085d6", confirmButtonText: "Ok" });
        return;
      }
      if (valMin && valMax && parseFloat(valMin) > parseFloat(valMax)) {
        this.setState({ loading: false });
        this.context.hideLoading();
        Swal.fire({ text: "Valor mínimo maior que o valor máximo.", title: "Aviso", icon: "warning", confirmButtonColor: "#3085d6", confirmButtonText: "Ok" });
        return;
      }

      const nf = this.state.filtro_nota_fiscal;
      const serie = this.state.filtro_serie_nota_fiscal;
      if ((nf && !serie) || (!nf && serie)) {
        this.setState({ loading: false });
        this.context.hideLoading();
        Swal.fire({ text: "Preencha ambos os campos de Nota Fiscal (número e série).", title: "Aviso", icon: "warning", confirmButtonColor: "#3085d6", confirmButtonText: "Ok" });
        return;
      }
    }

    return true;
  }

  async integraPedido() {
    this.setState({ table: [] });

    if (this.context.userSession.papelCategoria === "LABORATORIO") {
      const oticaCnpj = CnpjUtils.cleanCnpj(this.props.cnpj_number);
      const labCnpj = this.props.laboratorio_dados.laboratorio_cnpj;
      const relacionamento = await Relacionamento(labCnpj, oticaCnpj);
      if (relacionamento === false) {
        this.context.hideLoading();
        this.setState({ loading: false });
        Swal.fire({
          text: "A ótica informada não possui relacionamento com o laboratório.",
          title: "Aviso",
          icon: "warning",
          confirmButtonColor: "#00518b",
          confirmButtonText: "Ok",
        });
        return;
      }
    }

    const requestOptions = {
      method: "GET",
      headers: {
        access_token: sessionStorage.getItem("token"),
        client_id: localStorage.getItem("clientid"),
        laboratorio: this.props.laboratorio_dados.laboratorio_cnpj,
        otica: CnpjUtils.cleanCnpj(this.props.cnpj_number),
      },
    };
    let filterParams = "";
    if (this.props.novosFiltrosFinanceiros) {
      const filters = {
        numeroDocumento: this.state.filtro_numero_documento,
        dataVencimentoInicial: this.state.filtro_vencimento_data_inicio,
        dataVencimentoFinal: this.state.filtro_vencimento_data_fim,
        valorFaturaInicial: this.state.filtro_valor_minimo,
        valorFaturaFinal: this.state.filtro_valor_maximo,
        numeroNotaFiscal: this.state.filtro_nota_fiscal,
        serieNotaFiscal: this.state.filtro_serie_nota_fiscal,
      };
      Object.keys(filters).forEach(key => { if (!filters[key]) delete filters[key]; });
      const extra = Object.entries(filters).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
      if (extra) filterParams = "&" + extra;
    }

    var finalData = [];
    var statuses = ["BAIXADO", "PENDENTE"];
    for (let status of statuses) {
      let data = [];

      const response = await fetch(process.env.REACT_APP_ESSILOR_API + `gestao-financeira-cliente-laboratorio/v1/faturas?status=${status}${filterParams}`, requestOptions);

      if (response.status === 200) {
        const datas = await response.json();

        datas.forEach(fatura => {
          data.push({
            codigo: fatura.codigo,
            parcela: fatura.parcela,
            nDocumento: fatura.numeroDocumento,
            dataEmissao: fatura.dataEmissao,
            dataVencimento: fatura.dataVencimento,
            valor: fatura.valor,
            valorAberto: fatura.valorAberto,
            status: fatura.status,
          });
        });

        finalData = [...finalData, ...data];
      } else {
        Swal.fire({
          text: "Falha de comunicação com o laboratório. Tente novamente mais tarde.",
          title: "Aviso",
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        });
        break;
      }
    }
    var groupedData = finalData.reduce((accumulator, currentValue) => {
      const documentNumber = currentValue.nDocumento.replace(/\s/g, "");
      const today = new Date();

      const existingGroup = accumulator.find(group => {
        const existingDocumentNumber = group["N° Documento"];

        if (existingDocumentNumber === documentNumber) {
          return true;
        }
      });

      const parcela = `${currentValue.parcela.slice(0, -2)}/${currentValue.parcela.slice(-2)}`;
      const valorNumerico = Math.round(currentValue.valor * 100) / 100;

      currentValue.status = statusParcela(currentValue.status, currentValue.dataVencimento, today);
      currentValue.parcela = parcela;

      if (existingGroup) {
        existingGroup.detalhes.push(currentValue);

        existingGroup.valor = (parseFloat(valorNumerico) + parseFloat(existingGroup.valor)).toFixed(2);
      } else {
        accumulator.push({
          "N° Documento": documentNumber,
          "Data Emissão": Moment(currentValue.dataEmissao).format("DD/MM/YYYY"),
          "Data Vencimento": "",
          valor: valorNumerico,
          detalhes: [currentValue],
        });
      }
      return accumulator;
    }, []);

    groupedData.forEach(documento => {
      const detalhes = documento.detalhes;
      const temStatusEmAberto = detalhes.some(detalhe => detalhe.status !== "Pago");
      if (temStatusEmAberto) {
        documento.status = "EM ABERTO";
      } else {
        documento.status = "PAGO";
      }
      const vencimento = proximoVencimento(detalhes);
      documento["Data Vencimento"] = vencimento ? Moment(vencimento).format("DD/MM/YYYY") : "-";
    });
    this.setState({
      table: groupedData,
      APIData: finalData,
      resposta_tabela: true,
      loading: false,
    });
    this.context.hideLoading();
  }

  render() {
    const { redirectL } = this.state;

    if (this.state.redirect) {
      return <Redirect to="/home" />;
    }

    if (redirectL) {
      return <Redirect to="/" />;
    }
    var headers = [];
    var tableData = [];
    if (this.state.table?.length >= 1) {
      headers = Object.keys(this.state.table[0]).filter(header => header !== "detalhes");
      tableData = this.state.table.map(item => ({ ...item }));
    }
    return (
      <>
        <div id="main-financeiro">
          <Collapse in={this.props.novosFiltrosFinanceiros} timeout={400}>
            <Divider style={{ marginTop: "3.5rem", marginBottom: "2rem" }} light />
            <div className="financeiro-novos-filtros">
              <div className="row d-flex justify-content-center">
                <div className="col-xs-12 col-md-5">
                  <TextField
                    variant="outlined"
                    className="lp-field"
                    label="Número do documento"
                    name="filtro_numero_documento"
                    value={this.state.filtro_numero_documento}
                    onChange={this.handleChangeFiltro}
                    autoComplete="off"
                  />
                </div>
                <div className="col-xs-6 col-md-3">
                  <DatePicker
                    selected={this.state.filtro_vencimento_dia_inicio}
                    onChange={this.handleChangeFiltroVencimentoInicio}
                    dateFormat="dd/MM/yyyy"
                    locale="pt"
                    autoComplete="off"
                    customInput={
                      <TextField variant="outlined" className="lp-field" label="Data de vencimento inicial"
                        error={!!this.getDataVencimentoError().ini}
                        helperText={this.getDataVencimentoError().ini} />
                    }
                  />
                </div>
                <div className="col-xs-6 col-md-3">
                  <DatePicker
                    selected={this.state.filtro_vencimento_dia_fim}
                    onChange={this.handleChangeFiltroVencimentoFim}
                    dateFormat="dd/MM/yyyy"
                    locale="pt"
                    autoComplete="off"
                    customInput={
                      <TextField variant="outlined" className="lp-field" label="Data de vencimento final"
                        error={!!this.getDataVencimentoError().fim}
                        helperText={this.getDataVencimentoError().fim} />
                    }
                  />
                </div>
              </div>

              <div className="row d-flex justify-content-center">
                <div className="col-xs-6 col-md-3">
                  <TextField
                    variant="outlined"
                    className="lp-field"
                    label="Valor mínimo"
                    name="filtro_valor_minimo"
                    value={this.formatCurrencyDisplay(this.state.filtro_valor_minimo)}
                    onChange={this.handleCurrencyChange("filtro_valor_minimo")}
                    autoComplete="off"
                    error={!!this.getValorError().min}
                    helperText={this.getValorError().min}
                  />
                </div>
                <div className="col-xs-6 col-md-3">
                  <TextField
                    variant="outlined"
                    className="lp-field"
                    label="Valor máximo"
                    name="filtro_valor_maximo"
                    value={this.formatCurrencyDisplay(this.state.filtro_valor_maximo)}
                    onChange={this.handleCurrencyChange("filtro_valor_maximo")}
                    autoComplete="off"
                    error={!!this.getValorError().max}
                    helperText={this.getValorError().max}
                  />
                </div>
                <div className="col-xs-6 col-md-3">
                  <TextField
                    variant="outlined"
                    className="lp-field"
                    label="Nota fiscal"
                    name="filtro_nota_fiscal"
                    value={this.state.filtro_nota_fiscal}
                    onChange={this.handleChangeFiltro}
                    autoComplete="off"
                  />
                </div>
                <div className="col-xs-6 col-md-2">
                  <TextField
                    variant="outlined"
                    className="lp-field"
                    label="Série"
                    name="filtro_serie_nota_fiscal"
                    value={this.state.filtro_serie_nota_fiscal}
                    onChange={this.handleChangeFiltro}
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
          </Collapse>

          <div className="row">
            <TrackingSearchButton onClick={this.changeState} />
          </div>

          <section ref={ref => (this.myRef = ref)} className="mt-4">
            {this.state.table?.length >= 1 && (
              <TableHead headers={headers} data={this.state.table} APIData={this.state.APIData} info={this.props.laboratorio_dados} cnpj_number={this.props.cnpj_number} />
            )}
            {this.state.table !== null && this.state.table?.length === 0 && !this.state.loading && (
              <EmptyState
                icon={Search}
                title="Nenhum registro encontrado"
                description={this.props.novosFiltrosFinanceiros ? "Tente ajustar os filtros para encontrar resultados." : "Não foram encontradas faturas para o laboratório selecionado."}
              />
            )}
          </section>
        </div>
      </>
    );
  }
}

export default BuscaFaturas;
